<template>
    <v-container>
        <v-card class="mb-4">
            <v-toolbar flat class="grey lighten-4">
                <v-toolbar-title>Автопоиск</v-toolbar-title>
            </v-toolbar>
            <v-card-text v-if="loading" class="text-center"><v-progress-circular indeterminate color="primary" /></v-card-text>
            <v-card-text v-else-if="error">
                <v-alert type="error" text dense>{{ error }}</v-alert>
                <v-btn @click="loadSearches" text color="primary">Повторить</v-btn>
            </v-card-text>
            <v-card-text v-else-if="!searches.length" class="text-center">
                <p>У вас пока нет сохранённых поисков.</p>
                <p>Выберите фильтры на странице поиска и нажмите кнопку с лупой и сердцем рядом с «Найти».</p>
                <v-btn :to="{ name: 'Search' }" color="primary">Перейти к поиску</v-btn>
            </v-card-text>
        </v-card>
        <v-card v-for="item in searches" :key="item.id" class="mb-4">
            <v-card-title class="align-start">
                <span class="saved-search-title">{{ item.name }}</span>
                <v-btn @click="openRename(item)" icon small class="ml-2" :aria-label="'Переименовать ' + item.name" title="Переименовать">
                    <v-icon small>mdi-pencil</v-icon>
                </v-btn>
                <v-spacer />
                <span class="caption grey--text">Добавлен {{ $moment(item.created).format('DD.MM.YYYY HH:mm') }}</span>
            </v-card-title>
            <v-card-text><search-filter-summary :items="item.summary" /></v-card-text>
            <v-card-actions>
                <v-btn @click="openRemove(item)" text color="error"><v-icon small class="mr-1">mdi-delete-outline</v-icon>Удалить</v-btn>
                <v-spacer />
                <v-btn :to="{ name: 'Search', query: { savedSearch: String(item.id) } }" color="primary">
                    <v-icon small class="mr-1">mdi-magnify</v-icon>Поиск
                </v-btn>
            </v-card-actions>
        </v-card>
        <saved-search-dialog
            v-model="rename.show"
            title="Переименовать поиск"
            :name="rename.item ? rename.item.name : ''"
            :summary="rename.item ? rename.item.summary : []"
            :progress="rename.progress"
            :error="rename.error"
            :name-errors="rename.nameErrors"
            @save="renameSearch"
        />
        <v-dialog v-model="remove.show" :persistent="remove.progress" max-width="500">
            <v-card>
                <v-card-title>Удалить сохранённый поиск?</v-card-title>
                <v-card-text class="saved-search-title">
                    <v-alert v-if="remove.error" type="error" text dense>{{ remove.error }}</v-alert>
                    Поиск «{{ remove.item ? remove.item.name : '' }}» будет удалён из избранного.
                </v-card-text>
                <v-card-actions>
                    <v-spacer />
                    <v-btn @click="remove.show = false" :disabled="remove.progress" text>Отмена</v-btn>
                    <v-btn @click="removeSearch" :loading="remove.progress" color="error">Удалить</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
import SearchFilterSummary from '../SearchFilterSummary.vue'
import SavedSearchDialog from '../SavedSearchDialog.vue'

export default {
    name: 'AutoSearchController',
    components: {SearchFilterSummary, SavedSearchDialog},
    data () {
        return {
            searches: [],
            loading: false,
            error: '',
            rename: {show: false, item: null, progress: false, error: '', nameErrors: []},
            remove: {show: false, item: null, progress: false, error: ''},
        }
    },
    created () { this.loadSearches() },
    methods: {
        loadSearches () {
            this.loading = true
            this.error = ''
            return this.$axios.post('/console/saved-search/list').then(res => {
                if (res.data.success) this.searches = res.data.data
                else this.error = 'Не удалось загрузить сохранённые поиски.'
            }).catch(() => {
                this.error = 'Не удалось загрузить сохранённые поиски.'
            }).finally(() => { this.loading = false })
        },
        openRename (item) {
            this.rename.item = item
            this.rename.error = ''
            this.rename.nameErrors = []
            this.rename.show = true
        },
        renameSearch (name) {
            if (this.rename.progress) return
            this.rename.progress = true
            this.rename.error = ''
            this.rename.nameErrors = []
            return this.$axios.post('/console/saved-search/rename', {id: this.rename.item.id, name}).then(res => {
                if (res.data.success) {
                    this.rename.item.name = res.data.data.name
                    this.rename.show = false
                } else {
                    this.rename.nameErrors = res.data.errors.name || []
                    if (!this.rename.nameErrors.length) this.rename.error = 'Не удалось переименовать поиск.'
                }
            }).catch(() => {
                this.rename.error = 'Не удалось переименовать поиск. Повторите попытку.'
            }).finally(() => { this.rename.progress = false })
        },
        openRemove (item) {
            this.remove.item = item
            this.remove.error = ''
            this.remove.show = true
        },
        removeSearch () {
            if (this.remove.progress) return
            this.remove.progress = true
            this.remove.error = ''
            return this.$axios.post('/console/saved-search/remove', {id: this.remove.item.id}).then(res => {
                if (res.data.success) {
                    this.searches = this.searches.filter(item => item.id !== this.remove.item.id)
                    this.remove.show = false
                } else this.remove.error = 'Не удалось удалить поиск.'
            }).catch(() => {
                this.remove.error = 'Не удалось удалить поиск. Повторите попытку.'
            }).finally(() => { this.remove.progress = false })
        },
    },
}
</script>

<style scoped>
.saved-search-title {
    overflow-wrap: anywhere;
    word-break: normal;
}
</style>
